import React from 'react';
import { Button } from '@mui/material';
import { COLORS, FONT, RADIUS } from './tokens';
import PageHeader from './PageHeader';
import useIsMobile from '../../../helper/useIsMobile';

/*
 * FormCard — every add / edit form (2026-10-22): page headline, then a white card holding the
 * fields, then a footer bar with Cancel and Save on the right.
 *
 *   <FormCard title="Add Device" mode="new"
 *             onCancel={this.handleCancelDevice.bind(this)}
 *             onSave={this.handleSubmitDevice.bind(this)}>
 *       ...the screen's existing fields, unchanged...
 *   </FormCard>
 *
 * mode: 'new' | 'edit' — shows a small "New" / "Editing" tag next to the title.
 * The handlers are the screen's own; FormCard only lays them out. Pass `actions` instead of
 * onCancel/onSave for a footer with other buttons, or `footer={false}` for none.
 */
export function FormSection({ title, children, first }) {
    return (
        <div style={{ paddingTop: first ? 0 : 20, marginTop: first ? 0 : 4, borderTop: first ? 'none' : `1px solid ${COLORS.border}` }}>
            {title && (
                <div style={{
                    fontFamily: FONT, fontSize: 11, fontWeight: 700, letterSpacing: '0.08em',
                    textTransform: 'uppercase', color: COLORS.textDim, marginBottom: 12,
                }}>
                    {title}
                </div>
            )}
            {children}
        </div>
    );
}


export default function FormCard({
    title, subtitle, mode, breadcrumb, headerRight,
    onCancel, onSave, saveLabel = 'Save', cancelLabel = 'Cancel', saveDisabled = false,
    actions, footer, children, style,
}) {
    const isMobile = useIsMobile();   // phone: tighter padding, footer buttons wrap
    const footerContent = footer === false ? null : (actions || (
        <>
            {onCancel && <Button variant="outlined" onClick={onCancel}>{cancelLabel}</Button>}
            {onSave && <Button className="add-button" variant="contained" onClick={onSave} disabled={saveDisabled}>{saveLabel}</Button>}
        </>
    ));

    return (
        <div style={style}>
            <PageHeader
                breadcrumb={breadcrumb}
                title={title}
                mode={mode}
                subtitle={subtitle}
                right={headerRight}
            />
            <div style={{
                background: COLORS.surface, border: `1px solid ${COLORS.border}`, borderRadius: RADIUS.card,
                marginBottom: 16,
            }}>
                <div style={{ padding: isMobile ? '16px 14px 4px' : '20px 20px 8px' }}>{children}</div>
                {footerContent && (
                    <div style={{
                        display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8,
                        ...(isMobile ? { flexWrap: 'wrap' } : {}),
                        padding: isMobile ? '12px 14px' : '12px 20px', borderTop: `1px solid ${COLORS.border}`,
                        background: COLORS.surfaceAlt, borderRadius: `0 0 ${RADIUS.card}px ${RADIUS.card}px`,
                    }}>
                        {footerContent}
                    </div>
                )}
            </div>
        </div>
    );
}
